import { render, staticRenderFns } from "./ProjectPlatformView.vue?vue&type=template&id=1edff9cd&scoped=true"
import script from "./ProjectPlatformView.vue?vue&type=script&lang=js"
export * from "./ProjectPlatformView.vue?vue&type=script&lang=js"
import style0 from "./ProjectPlatformView.vue?vue&type=style&index=0&id=1edff9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1edff9cd",
  null
  
)

export default component.exports